import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthModule, StsConfigHttpLoader, AbstractLoggerService, StsConfigLoader, OpenIdConfiguration, LogLevel } from 'angular-auth-oidc-client';
import { environment } from '../../environments';
import { ApplicationConfiguration } from '@model';
import { ClientType } from '@enums';
import { OidcLoggerService } from './oidc-logger.service';

export const httpLoaderFactory = (http: HttpClient) => {
    const configUrl = environment.apiEndpoint + '/appsettings';
    const ownUrl = window.location.protocol + '//' + window.location.host;
    //console.log(`auth-config.module\thttpLoaderFactory\townUrl: ${ownUrl}`);

    let configs$: Observable<OpenIdConfiguration[]> = http.get<ApplicationConfiguration>(configUrl)
        .pipe(
            map(apiConfig => {
                let scopes = apiConfig.scope;
                let brf: OpenIdConfiguration = {
                    authority: apiConfig.stsServer,
                    redirectUrl: ownUrl + '/landing',
                    configId: ClientType.Brf,
                    clientId: ClientType.Brf,
                    scope: scopes.replace('sxit.', 'sxit.brf'),
                    responseType: 'code',
                    autoUserInfo: true,
                    startCheckSession: false,
                    silentRenew: apiConfig.silent_renew,
                    silentRenewUrl: ownUrl + '/silent-renew.html',
                    silentRenewTimeoutInSeconds: 20, // 20 seconds is default value in angular-auth-oidc-client
                    logLevel: apiConfig.log_console_warning_active ? LogLevel.Warn : apiConfig.log_console_debug_active ? LogLevel.Debug : LogLevel.None,
                    triggerAuthorizationResultEvent: true,
                    forbiddenRoute: '/forbidden',
                    unauthorizedRoute: '/unauthorized',
                    maxIdTokenIatOffsetAllowedInSeconds: apiConfig.max_id_token_iat_offset_allowed_in_seconds,
                    checkRedirectUrlWhenCheckingIfIsCallback: true,
                    useRefreshToken: false
                };
                let company = {...brf, clientId: ClientType.Company, configId: ClientType.Company, scope: scopes.replace('sxit.', 'sxit.company')};
                let villa = {...brf, clientId: ClientType.Private, configId: ClientType.Private, scope: scopes.replace('sxit.', 'sxit.private')};
                let manager = {...brf, clientId: ClientType.Manager, configId: ClientType.Manager, scope: scopes.replace('sxit.', 'sxit.manager')};
                /*
                console.log(`auth-config.module\thttpLoaderFactory\tlog_console_warning_active: ${apiConfig.log_console_warning_active}`);
                console.log(`auth-config.module\thttpLoaderFactory\tlog_console_debug_active: ${apiConfig.log_console_debug_active}`);
                console.log(`auth-config.module\thttpLoaderFactory\tlogLevel: ${brf.logLevel}`);
                */
                return [ brf, company, villa, manager ];
            })
        );

    return new StsConfigHttpLoader(configs$);
};

@NgModule({
    imports: [
        AuthModule.forRoot({
            loader: {
                provide: StsConfigLoader,
                useFactory: httpLoaderFactory,
                deps: [ HttpClient ],
            }
        })
    ],
    providers: [ { provide: AbstractLoggerService, useClass: OidcLoggerService } ],
    exports: [ AuthModule ]
})
export class AuthConfigModule{}